/**
 * escribe aqui tus variables globales
 */

export const project_config = {
    MONITORING_TRACING: {
        GOOGLE_ANALYTICS: {
            ACTIVO: true,
        },
        SENTRY: {
            ACTIVO: true,
        },
        HANDLE_ERROR: {
            CONSOLE_LOG: true,
        },
    },
    IDLE: {
        ACTIVO: false,
        TIEMPO_SESION: 900,
        TIEMPO_AVISO: 180,
    },
    SISTEMA: {
        LINKS: {
            AYUDA: {
                BUTTONS: {
                    PASO_A_PASO: false,
                },
            },
        },
        LANDING: '',
        MENUS: {
            ITEMS_ICON: true,
            FLAT_ICONS: true,
            METODO_ACTIVO: '',
        },
        URL: {
            PATHMENUSIMG: 'imagenes/iconos_sistemas/menus/<directorio>/',
            PATHITEMSIMG: 'imagenes/iconos_sistemas/menus/items/<directorio>/',
            PATHSTATIC: '/static/sistemas/<directorio>/',
        },
    },
};
